import { render } from "./ConfirmationDialogComponent.vue?vue&type=template&id=40aac05e&ts=true"
import script from "./ConfirmationDialogComponent.vue?vue&type=script&lang=ts"
export * from "./ConfirmationDialogComponent.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src186264411/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__